import Layout from "@/components/layout/Layout";
import { COMPANY_FISCAL_DATA, LOCATION_FISCAL_DATA } from "@/constants/fiscal";

const AvisoLegal = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="font-serif text-4xl font-bold text-primary mb-8">Aviso Legal</h1>
        
        <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">1. Datos Identificativos del Titular</h2>
            <div className="bg-muted/50 p-6 rounded-lg">
              <ul className="space-y-2 text-foreground">
                <li><strong>Razón Social:</strong> {COMPANY_FISCAL_DATA.razonSocial}</li>
                <li><strong>CIF:</strong> {COMPANY_FISCAL_DATA.cif}</li>
                <li><strong>Forma Jurídica:</strong> {COMPANY_FISCAL_DATA.formaJuridica}</li>
                <li><strong>CNAE:</strong> {COMPANY_FISCAL_DATA.cnae} - {COMPANY_FISCAL_DATA.actividadPrincipal}</li>
                <li><strong>Inscripción:</strong> {COMPANY_FISCAL_DATA.registroMercantil}</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">2. Domicilios Sociales</h2>
            <div className="grid gap-4 md:grid-cols-3">
              {Object.values(LOCATION_FISCAL_DATA).map((location) => (
                <div key={location.serieFactura} className="bg-muted/50 p-4 rounded-lg">
                  <h3 className="font-semibold text-foreground">{location.name.replace('Pastelería Reyes - ', '')}</h3>
                  <p className="text-sm text-muted-foreground mt-1">{location.fullAddress}</p>
                  <p className="text-sm text-muted-foreground">Tel: {location.phone}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">3. Objeto y Ámbito de Aplicación</h2>
            <p className="text-muted-foreground leading-relaxed">
              El presente aviso legal regula el uso del sitio web de {COMPANY_FISCAL_DATA.razonSocialCorta}, 
              dedicada a la {COMPANY_FISCAL_DATA.actividadPrincipal.toLowerCase()}. El acceso y navegación 
              por este sitio web implica la aceptación plena de las presentes condiciones.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">4. Propiedad Intelectual</h2>
            <p className="text-muted-foreground leading-relaxed">
              Todos los contenidos del sitio web (textos, fotografías, gráficos, imágenes, iconos, tecnología, 
              software, así como su diseño gráfico y códigos fuente) son propiedad intelectual de 
              {COMPANY_FISCAL_DATA.razonSocialCorta} o de terceros, sin que puedan entenderse cedidos al 
              usuario ninguno de los derechos de explotación sobre los mismos.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">5. Condiciones de Uso</h2>
            <p className="text-muted-foreground leading-relaxed">
              El usuario se compromete a utilizar el sitio web de conformidad con la ley, el presente Aviso Legal, 
              la moral y las buenas costumbres generalmente aceptadas. El usuario se obliga a abstenerse de 
              utilizar el sitio web con fines o efectos ilícitos, contrarios al contenido del presente Aviso Legal.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">6. Exclusión de Responsabilidad</h2>
            <p className="text-muted-foreground leading-relaxed">
              {COMPANY_FISCAL_DATA.razonSocialCorta} no garantiza la disponibilidad continua del sitio web, 
              quedando eximida de cualquier responsabilidad derivada de la falta de disponibilidad por razones 
              de mantenimiento u otras causas ajenas a su control.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">7. Legislación Aplicable</h2>
            <p className="text-muted-foreground leading-relaxed">
              Este Aviso Legal se rige por la legislación española. Para cualquier controversia que pudiera 
              derivarse del acceso o uso de este sitio web, las partes se someten a la jurisdicción de los 
              Juzgados y Tribunales de Las Palmas de Gran Canaria.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">8. Sistema de Facturación</h2>
            <p className="text-muted-foreground leading-relaxed">
              Este sitio web utiliza un sistema de facturación electrónica adaptado a la normativa Verifactu 
              (RD 1007/2023) para la generación de facturas simplificadas. Todos los documentos fiscales 
              emitidos cumplen con el Reglamento de Facturación RD 1619/2012.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-border">
          <p className="text-sm text-muted-foreground text-center">
            Última actualización: Enero 2026
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default AvisoLegal;
